<template>
  <div class="home-content-page-v">
    <div class="one-content">
      <content-title title="模型参数设定"></content-title>
      <div class="setting-content">
        <div class="model-setting">
          <div class="one-model-setting">
            <span>车辆数</span>
            <el-input placeholder="请输入内容" :disabled="solutionStatus > 20" v-model="groupsNum">
              <template slot="append">辆</template>
            </el-input>
          </div>
          <div class="one-model-setting">
            <span>每个群主最大客户数</span>
            <el-input placeholder="请输入内容" :disabled="solutionStatus > 20" v-model="maxCustomersNum">
              <template slot="append">个</template>
            </el-input>
          </div>
          <div class="one-model-setting">
            <span>车辆调度模型的TimeLimit</span>
            <el-input placeholder="请输入内容" :disabled="solutionStatus > 20" v-model="groupTimeLimit">
              <template slot="append">秒</template>
            </el-input>
          </div>
          <div class="one-model-setting">
            <span>车辆调度模型的MIPGap</span>
            <el-input placeholder="请输入内容" :disabled="solutionStatus > 20" v-model="groupMipGap">
              <template slot="append"> % </template>
            </el-input>
          </div>
          <div class="one-model-setting one-model-last">
            <span>路径规划模型的TimeLimit</span>
            <el-input placeholder="请输入内容" :disabled="solutionStatus > 20" v-model="routeTimeLimit">
              <template slot="append">秒</template>
            </el-input>
          </div>
        </div>
        <div class="m-line">
          <a href="javascript:;" class="show-note" @click="show_note = !show_note">{{show_note ? '隐藏解析' : '显示解析'}}</a>
        </div>
          <div class="setting-note">
        <transition name="bounce" v-if="show_note">
        <template>
          <div>
            <span v-html="setting_note"></span>
            <li v-for="note in notes">{{note}}</li>
          </div>
        </template>
        </transition>
          </div>

      </div>
    </div>
    <div class="gu-duan">
    </div>
    <div class="two-content">
      <div class="content-1">
        <content-title title="求解日期选择"></content-title>
        <div class="checkbox-content">
          <span>该系统解决的是单日的配送问题，所以请选择所要查看配送安排的日期。</span>
          <a href="javascript:;" class="checkbox-one" v-for="(week, index) in solutionWeeks" @click="solutionStatus > 20 ? null :solutionDay=index">
            <img src="~assets/checked-2.png" alt="" v-if="solutionDay === index">
            <img src="~assets/unchecked-2.png" alt="" v-if="solutionDay !== index">
            <div class="checkbox-label">
              {{week}}
            </div>
          </a>
        </div>
      </div>
      <div style="width: 4em;">
      </div>
      <div class="content-1">
        <content-title title="求解器选择"></content-title>
        <div class="checkbox-content">
          <a href="javascript:;" class="checkbox-one" v-for="(type, index) in solutionWays" @click="solutionStatus > 20 ? null :solutionWay=index">
            <img src="~assets/checked-2.png" alt="" v-if="solutionWay === index">
            <img src="~assets/unchecked-2.png" alt="" v-if="solutionWay !== index">
            <div class="checkbox-label">
              {{type}}
            </div>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import ContentTitle from '@/components_bit/ContentTitle'
  export default {
    components: {
      ContentTitle
    },
    created () {
      if (this.solutionStatus === 10) {
        this.$store.dispatch('setSolutionStatus', 20)
      }
    },
    computed: {
      groupsNum: {
        get () {
          return this.$store.getters.groupsNum
        },
        set (value) {
          return this.$store.dispatch('setGroupsNum', value)
        }
      },
      solutionStatus: {
        get () {
          return this.$store.getters.solutionStatus
        }
      },
      maxCustomersNum: {
        get () {
          return this.$store.getters.maxCustomersNum
        },
        set (value) {
          return this.$store.dispatch('setMaxCustomersNum', value)
        }
      },
      groupTimeLimit: {
        get () {
          return this.$store.getters.groupTimeLimit
        },
        set (value) {
          return this.$store.dispatch('setGroupTimeLimit', value)
        }
      },
      groupMipGap: {
        get () {
          return this.$store.getters.groupMipGap * 100
        },
        set (value) {
          return this.$store.dispatch('setGroupMipGap', value / 100)
        }
      },
      routeTimeLimit: {
        get () {
          return this.$store.getters.routeTimeLimit
        },
        set (value) {
          return this.$store.dispatch('setRouteTimeLimit', value)
        }
      },
      routeMipGap: {
        get () {
          return this.$store.getters.routeMipGap
        },
        set (value) {
          return this.$store.dispatch('setRouteMipGap', value)
        }
      },
      solutionWay: {
        get () {
          return this.$store.getters.solutionWay
        },
        set (value) {
          return this.$store.dispatch('setSolutionWay', value)
        }
      },
      solutionDay: {
        get () {
          return this.$store.getters.solutionDay
        },
        set (value) {
          return this.$store.dispatch('setSolutionDay', value)
        }
      },
      solutionWeeks: {
        get () {
          return this.$store.getters.solutionWeeks
        }
      },
      solutionWays: {
        get () {
          return this.$store.getters.solutionWays
        }
      }
    },
    data () {
      return {
        show_note: true,
        setting_note: `
        本解决方案分为两步求解，第一步求解车辆调度模型，该模型把所有订单分群组，一辆车服务一个群组里的所有客户。<br>第二步求解路径规划模型，该模型为每个车辆分别规划配送路线。
        `,
        notes: ['车辆数 ———— 所能调配的车辆总数', '每个车辆配送最大客户数 ———— 每辆车所能配送的最大客户数', '车辆调度模型的TimeLimit ———— 允许车辆调度模型求解的最大时间(单位：秒)', '车辆调度模型的MIPGap ———— 当目标函数的最小值和最大值的差值的绝对值小于最大值的MIPGap倍时，求解器会终止并返回一个最优解。空格中填写的默认为小数，比如填写0.01则该模型的MIPGap为1%。', '路径规划模型的TimeLimit ———— 允许车辆调度模型求解的最大时间(单位：秒)', '路径规划模型的MIPGap ———— 当目标函数的最小值和最大值的差值的绝对值小于最大值的MIPGap倍时，求解器会终止并返回一个最优解。空格中填写的默认为小数，比如填写0.01则该模型的MIPGap为1%']
      }
    }
  }
</script>
<style lang="less">
  .one-model-setting .el-input-group {
    width: 17em;
  }
</style>

<style scoped lang="less">
  @import '../../style/base.less';
  .bounce-enter-active {
    animation: bounce-in .5s reverse;
  }
  .bounce-leave-active {
    animation: bounce-in .5s reverse;
  }
  .bounce-leave-to {
    transform: scale(0);
  }
  @keyframes bounce-in {
    0% {
      transform: scale(0);
    }
    100% {
      transform: scale(1);
    }
  }
  .two-content {
    display: flex;
  }
  .hide-note {
    transform:rotateY(270deg);
    color: #fff;
  }

  .gu-duan {
    width: 100%;
    height: 1.3em;
  }
  .gu-duan-width {
    width: 7.6em;
    height: 100%;
  }
  .setting-content {
    .content-shadow;
    .content-bottom-radius;
    padding: 2.2em;
    display: flex;
    background-color: #fff;
    justify-content: space-between;
  }
  .model-setting {
    width: 31em;
    display: flex;
    flex-direction: column;
  }
  .one-model-setting {
    margin-bottom: 2.2em;
    justify-content: space-between;
    align-items: center;
    display: flex;
    span {
      font-size: 1em;
      color: @bak-color-1;
    }
    input:focus {
      outline:none;
    }
    input {
      margin-left: 2em;
      border: 1px solid #999;
      border-radius: 3px;
      padding: 2px 1em;
      width: 11em;
      font-size: 1.13em;
      background-color: rgba(0, 0,0,0)
    }
  }
  .content-1 {
    .content-shadow;
    .content-radius;
    flex: 1;
    display: flex;
    background-color: #fff;
    flex-direction: column;
    height: 20em;
  }
  .one-model-last {
    margin-bottom: 0em;
  }
  .checkbox-content {
    padding: 1.38em 2.2em;
    display: flex;
    flex-direction: column;
    span {
      line-height: 1;
      font-size: 0.8em;
      color: @bak-color-2;
    }
  }
  .m-line {
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 1em;
    border-right: 3px solid #ccc;
    .show-note {
      display: flex;
      justify-content: center;
      background: #486881;
      color: #fff;
      font-size: 0.9em;
      padding: 0.5em 0.3em;
      border-bottom-left-radius: 0.8em;
      border-top-left-radius: 0.8em;
    }
  }
  .setting-note {
    transition: 1s;
    padding-right: 2em;
    width:50em;
    line-height: 2;
    color: @bak-color-2;
    font-size: 0.88em;
  }
  .checkbox-one {
    display: flex;
    align-items: center;
    height: 2.5em;
    font-size: 1em;
    color:@bak-color-1;
    img {
      padding: 0 1em;
    }
  }
</style>



// WEBPACK FOOTER //
// setting_to.vue?0e87b9ac